'use client';

import Footer from './Footer';
import { usePathname } from 'next/navigation';
import GuestFooter from './GuestFooter';

const HIDE_FOOTER_ROUTES = [
  '/admin/login',
  '/create-account',
  '/sign-in',
  '/reset-password',
  // Add more auth routes as needed
];

const GUEST_FOOTER_ROUTES = [
  '/fares',
  '/schedule',
  '/contact-us',
  '/terms-services',
  '/privacy-policy',
  '/faq',
  '/our-history',
  '/'
];

export default function FooterWrapper() {
  const pathname = usePathname();


  const shouldHideFooter = HIDE_FOOTER_ROUTES.some(route => pathname.startsWith(route));
  if (shouldHideFooter) return null;

  const shouldShowGuestFooter = GUEST_FOOTER_ROUTES.some(route => {
    if (route === '/') {
      return pathname === '/';
    }
    return pathname.startsWith(route);
  });

  // Return the appropriate footer
  return shouldShowGuestFooter ? <GuestFooter /> : <Footer />;
}